import React, {useCallback, useEffect, useState} from "react";
import withStoreAuth from "../../../auth/StoreRouteAuth";
import StoreLayout from "./StoreLayout";
import StoreChatPanel from "./StoreChatPanel";
import {storeGet, storePost} from "../../../services/storeApi";

/**
 * 상점사(쇼핑몰) 채팅문의
 *  - 경로 : /store/api/chat
 *  - 말풍선/입력창 UI 는 StoreChatPanel 에 있다.
 *    (관리자 [상점사] 탭이 쓰는 StoreChatBoard 와는 별개 — 관리자 화면 디자인은 그대로 유지)
 */
function StoreChatPg() {

    const [info, setInfo] = useState(null);

    useEffect(() => {
        storeGet('/store/myInfo').then(res => setInfo(res.data)).catch(() => setInfo(null));
    }, []);

    /** 상점사 측 메세지 조회 */
    const loadMessages = useCallback(async () => {
        const res = await storeGet('/storeChat/store/messages');
        return res.data || [];
    }, []);

    /** 상점사 측 메세지 전송 */
    const sendMessage = useCallback(async (payload) => {
        const res = await storePost('/storeChat/store/send', payload);
        return res.data;
    }, []);

    return (
        <StoreLayout active="chat"
                     eyebrow="Support"
                     title="채팅문의"
                     desc="비토리지 담당자와 실시간으로 이야기하실 수 있습니다">
            <div className="st-rise st-rise-3">
                <StoreChatPanel storeSeqNum={info?.seqNum}
                                loadMessages={loadMessages}
                                sendMessage={sendMessage}/>
            </div>
        </StoreLayout>
    );
}

export default withStoreAuth(StoreChatPg);
